import React from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import IconButton from "@material-ui/core/IconButton";
import MoodIcon from "@material-ui/icons/Mood";
import useMessageInputStyles from "../messageInputStyles";

const EmojiOptions = (props) => {
  const { disabled, showEmoji, setShowEmoji, handleAddEmoji, hideButton } = props;
  const classes = useMessageInputStyles();
  return (
    <>
      {!hideButton && (
        <IconButton
          aria-label="emojiPicker"
          component="span"
          disabled={disabled}
          onClick={(e) => setShowEmoji((prevState) => !prevState)}
        >
          <MoodIcon className={classes.sendMessageIcons} />
        </IconButton>
      )}
      {showEmoji ? (
        <div className={classes.emojiBox}>
          <Picker
            perLine={16}
            showPreview={false}
            showSkinTones={false}
            onSelect={handleAddEmoji}
          />
        </div>
      ) : null}
    </>
  );
};

export default EmojiOptions;
